import { render, staticRenderFns } from "./biletentdetail.vue?vue&type=template&id=2e55deba&"
import script from "./biletentdetail.vue?vue&type=script&lang=js&"
export * from "./biletentdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports